// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_containerLevel__tDW84 {
    padding: 20px 0;
    flex-basis: 232px;
    margin: 0 0 auto 0;
}

.styles_containerLevel__tDW84:first-of-type {
    /*flex: 1;*/
}

.styles_inner__NvUbn {
    min-height: 0;
    padding: 0 10px;
}

.styles_button__f3LT8 {
    display: flex;
    align-items: center;
    grid-gap: 17px;
    padding: 0;
}

.styles_content__O\\+FXx {
    /*max-height: 0;*/
    /*overflow: hidden;*/
    /*transition: max-height 0.4s;*/
    padding-top: 20px;
    display: grid;
    grid-template-rows: 0fr; /* Start at 0 rows */
    transition: grid-template-rows 0.4s;
    /*overflow: hidden;*/
}

/* When the parent <details> is open, change the row size */
.styles_containerLevel__tDW84[open] + .styles_content__O\\+FXx,
.styles_containerLevel__tDW84[open] .styles_content__O\\+FXx {
    grid-template-rows: 1fr; /* Expand to full content size */
}

/*.content.open {*/
/*    max-height: 3000px;*/
/*}*/

/*.containerLevel:not(:last-of-type) {*/
/*    border-bottom: 1px solid #707070;*/
/*}*/

.styles_containerLevelHeader__gWT66 {
    display: flex;
    grid-gap: 10px;
    align-items: center;
    position: relative;
    border-bottom: 1px solid var(--light-grey);
    padding-bottom: 15px;
    cursor: pointer;
}

.styles_containerLevelHeader__gWT66 h5 {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
}

.styles_containerRow__tjxNV {
    position: relative;
    /*padding: 20px 40px;*/
    padding: 0 33px;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    grid-gap: 20px;
    transition:
        background-color 0.2s,
        box-shadow 0.2s;
}

.styles_containerRow__tjxNV > * {
    /*flex: 1;*/
    width: 31%;
}

/*.containerRow button {*/
/*    flex: 1;*/
/*    max-width: 300px;*/
/*}*/

.styles_containerRow__tjxNV.styles_secondary__uv5mF {
    /*padding: 0 40px;*/
    /*box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);*/
    margin-bottom: 8px;
    /*background: linear-gradient(to bottom, #fbfbfb 40%, #f0f3f7 100%);*/
}

/*.containerRow.secondary:first-child {*/
/*    margin-top: 20px;*/
/*}*/

.styles_containerRowAfter__sia6L {
    position: absolute;
    right: 10px;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 22px;
    width: 22px;
}

.styles_containerRowAfter__sia6L button {
    margin-left: auto;
}

/*.containerRow > * {*/
/*    max-width: 300px;*/
/*    flex: 1;*/
/*}*/

.styles_containerRow__tjxNV {
    position: relative;
}

.styles_typeIcon__wzOfF {
    position: absolute;
    top: 10px;
    width: 25px;
    height: 25px;
    margin-left: -35px;

    --icon-color-outer-custom: var(--primary-color-active);
    color: var(--dark-grey);
}

.styles_typeIcon__wzOfF span {
    height: 100%;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_typeIcon__wzOfF {
        top: 6px;
        margin-left: -28px;
        width: 20px;
        height: 20px;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_containerRow__tjxNV > * {
        max-width: 260px;
    }

    .styles_containerRow__tjxNV {
        padding: 0 26px;
    }

    .styles_containerRow__tjxNV.styles_secondary__uv5mF,
    .styles_containerRow__tjxNV {
        margin-bottom: 16px;
    }

    /*.containerRow button {*/
    /*    max-width: 260px;*/
    /*}*/
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .styles_containerRow__tjxNV > * {
        max-width: 300px;
    }

    .styles_containerRow__tjxNV {
        grid-gap: 30px;
    }

    .styles_containerRow__tjxNV.styles_secondary__uv5mF,
    .styles_containerRow__tjxNV {
        margin-bottom: 30px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SelectionPopup/SelectionLayoutRow/styles.module.css"],"names":[],"mappings":"AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,+BAA+B;IAC/B,iBAAiB;IACjB,aAAa;IACb,uBAAuB,EAAE,oBAAoB;IAC7C,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA,2DAA2D;AAC3D;;IAEI,uBAAuB,EAAE,gCAAgC;AAC7D;;AAEA,kBAAkB;AAClB,0BAA0B;AAC1B,IAAI;;AAEJ,uCAAuC;AACvC,wCAAwC;AACxC,IAAI;;AAEJ;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd;;uBAEmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA,yBAAyB;AACzB,eAAe;AACf,wBAAwB;AACxB,IAAI;;AAEJ;IACI,mBAAmB;IACnB,6CAA6C;IAC7C,kBAAkB;IAClB,qEAAqE;AACzE;;AAEA,wCAAwC;AACxC,wBAAwB;AACxB,IAAI;;AAEJ;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA,sBAAsB;AACtB,wBAAwB;AACxB,eAAe;AACf,IAAI;;AAEJ;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;;IAElB,sDAAsD;IACtD,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,QAAQ;QACR,kBAAkB;QAClB,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA,yBAAyB;IACzB,wBAAwB;IACxB,IAAI;AACR;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,mBAAmB;IACvB;AACJ","sourcesContent":["@value screen-lg-min, screen-md-max from '../../../breakpoints.css';\n\n.containerLevel {\n    padding: 20px 0;\n    flex-basis: 232px;\n    margin: 0 0 auto 0;\n}\n\n.containerLevel:first-of-type {\n    /*flex: 1;*/\n}\n\n.inner {\n    min-height: 0;\n    padding: 0 10px;\n}\n\n.button {\n    display: flex;\n    align-items: center;\n    grid-gap: 17px;\n    padding: 0;\n}\n\n.content {\n    /*max-height: 0;*/\n    /*overflow: hidden;*/\n    /*transition: max-height 0.4s;*/\n    padding-top: 20px;\n    display: grid;\n    grid-template-rows: 0fr; /* Start at 0 rows */\n    transition: grid-template-rows 0.4s;\n    /*overflow: hidden;*/\n}\n\n/* When the parent <details> is open, change the row size */\n.containerLevel[open] + .content,\n.containerLevel[open] .content {\n    grid-template-rows: 1fr; /* Expand to full content size */\n}\n\n/*.content.open {*/\n/*    max-height: 3000px;*/\n/*}*/\n\n/*.containerLevel:not(:last-of-type) {*/\n/*    border-bottom: 1px solid #707070;*/\n/*}*/\n\n.containerLevelHeader {\n    display: flex;\n    grid-gap: 10px;\n    align-items: center;\n    position: relative;\n    border-bottom: 1px solid var(--light-grey);\n    padding-bottom: 15px;\n    cursor: pointer;\n}\n\n.containerLevelHeader h5 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.containerRow {\n    position: relative;\n    /*padding: 20px 40px;*/\n    padding: 0 33px;\n    display: flex;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    grid-gap: 20px;\n    transition:\n        background-color 0.2s,\n        box-shadow 0.2s;\n}\n\n.containerRow > * {\n    /*flex: 1;*/\n    width: 31%;\n}\n\n/*.containerRow button {*/\n/*    flex: 1;*/\n/*    max-width: 300px;*/\n/*}*/\n\n.containerRow.secondary {\n    /*padding: 0 40px;*/\n    /*box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);*/\n    margin-bottom: 8px;\n    /*background: linear-gradient(to bottom, #fbfbfb 40%, #f0f3f7 100%);*/\n}\n\n/*.containerRow.secondary:first-child {*/\n/*    margin-top: 20px;*/\n/*}*/\n\n.containerRowAfter {\n    position: absolute;\n    right: 10px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    height: 22px;\n    width: 22px;\n}\n\n.containerRowAfter button {\n    margin-left: auto;\n}\n\n/*.containerRow > * {*/\n/*    max-width: 300px;*/\n/*    flex: 1;*/\n/*}*/\n\n.containerRow {\n    position: relative;\n}\n\n.typeIcon {\n    position: absolute;\n    top: 10px;\n    width: 25px;\n    height: 25px;\n    margin-left: -35px;\n\n    --icon-color-outer-custom: var(--primary-color-active);\n    color: var(--dark-grey);\n}\n\n.typeIcon span {\n    height: 100%;\n}\n\n@media screen-md-max {\n    .typeIcon {\n        top: 6px;\n        margin-left: -28px;\n        width: 20px;\n        height: 20px;\n    }\n}\n\n@media screen-md-max {\n    .containerRow > * {\n        max-width: 260px;\n    }\n\n    .containerRow {\n        padding: 0 26px;\n    }\n\n    .containerRow.secondary,\n    .containerRow {\n        margin-bottom: 16px;\n    }\n\n    /*.containerRow button {*/\n    /*    max-width: 260px;*/\n    /*}*/\n}\n\n@media screen-lg-min {\n    .containerRow > * {\n        max-width: 300px;\n    }\n\n    .containerRow {\n        grid-gap: 30px;\n    }\n\n    .containerRow.secondary,\n    .containerRow {\n        margin-bottom: 30px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"containerLevel": `styles_containerLevel__tDW84`,
	"inner": `styles_inner__NvUbn`,
	"button": `styles_button__f3LT8`,
	"content": `styles_content__O+FXx`,
	"containerLevelHeader": `styles_containerLevelHeader__gWT66`,
	"containerRow": `styles_containerRow__tjxNV`,
	"secondary": `styles_secondary__uv5mF`,
	"containerRowAfter": `styles_containerRowAfter__sia6L`,
	"typeIcon": `styles_typeIcon__wzOfF`
};
export default ___CSS_LOADER_EXPORT___;
